export default __webpack_public_path__ + "assets/images/58bc86d4581760a7a2f2f29579fa1c8a.svg";